/*
 * Desktop - PDP - Sticky CTA  --  variant: Sticky CTA
 * Moonshot experiment id: 33776766   status in Moonshot on 2026-08-27: DEPLOYED   started: 2025-07-10
 * Audience: DESKTOP   Target: pdp   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_pdp_d_sticky_cta
 */
MGExp.run('pdp_d_sticky_cta', { name: "Desktop - PDP - Sticky CTA / Sticky CTA", platform: 'desktop', target: 'pdp' }, function () {
  !(function () {
    let t = [],
      e = [];
    (t.push(), e.push());
    !(async function (i, n, a, o, s) {
      let c = {
        multi_target_selectors: t,
        page_identifier_selector: "section.prod-page",
        exclude_from_timeout: e,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(i, n, a, o, s, c);
    })(
      [
        "section.prod-page",
        "button#pdp-add-to-cart",
        "h1.pdp-product-title .pdp-product-title-text",
        "span.money#price",
        "div.product-image-slider div.imgs img",
      ],
      ".msai-sticky-cta-variant-applied",
      function (t, e) {
        const [i, n, a, o, s] = e,
          c = document.createElement("div");
        c.className = "msai-sticky-cta-container";
        const d = document.createElement("div");
        d.className = "msai-sticky-product-info";
        const r = document.createElement("img");
        ((r.className = "msai-sticky-product-image"),
          (r.src = s.src),
          (r.alt = a.textContent));
        const l = document.createElement("div");
        l.className = "msai-sticky-product-details";
        const m = document.createElement("div");
        ((m.className = "msai-sticky-product-title"),
          (m.textContent = a.textContent));
        const p = document.createElement("div");
        ((p.className = "msai-sticky-product-price"),
          (p.textContent = o.textContent));
        const u = document.createElement("button");
        ((u.className = "msai-sticky-cta-button"),
          (u.textContent = n.textContent),
          u.addEventListener("click", function () {
            n.click();
          }),
          l.appendChild(m),
          l.appendChild(p),
          d.appendChild(r),
          d.appendChild(l),
          c.appendChild(d),
          c.appendChild(u),
          document.body.appendChild(c),
          window.addEventListener("scroll", function () {
            n.getBoundingClientRect().top < 0
              ? c.classList.add("msai-visible")
              : c.classList.remove("msai-visible");
          }),
          i.classList.add("msai-sticky-cta-variant-applied"));
      },
      ".msai-sticky-cta-container{position:fixed;bottom:0;left:0;width:100%;background-color:#ffffff;box-shadow:0 -4px 10px rgba(0,0,0,0.1);padding:15px 20px;display:flex;justify-content:space-between;align-items:center;z-index:1000;transform:translateY(100%);transition:transform 0.3s ease-in-out;border-top:1px solid #f8f5eb}.msai-sticky-cta-container.msai-visible{transform:translateY(0)}.msai-sticky-product-info{display:flex;align-items:center;max-width:70%}.msai-sticky-product-image{width:60px;height:60px;object-fit:contain;margin-right:15px}.msai-sticky-product-details{display:flex;flex-direction:column}.msai-sticky-product-title{font-size:16px;font-weight:600;color:#000000;margin-bottom:5px;max-width:100%}.msai-sticky-product-price{font-size:16px;font-weight:600;color:#000000}.msai-sticky-cta-button{background-color:#000000;color:#ffffff;border:none;padding:12px 25px;font-size:14px;font-weight:600;cursor:pointer;transition:background-color 0.2s ease;min-width:180px}.msai-sticky-cta-button:hover{background-color:#333333}",
    );
  })();
});
